<div class="container mb-4">
  <div class="row">
    <div class="col-12">

      <div class="mt-5">
        <span class="text header-info header-mobile">Kwota odszkodowania</span>
      </div>

      <div class="mt-4">
        <span class="text item-type">{{ naglowekPrzedmiotuZgloszenia() }}</span>
      </div>

      <div class="mt-2">
        <span class="text content">Wyliczona kwota odszkodowania: </span>
        <span class="currency">{{ kwota | currency: 'PLN' : 'symbol': '3.2-2': 'pl' }}</span>
      </div>

      <div class="mt-5" *ngIf="(czyKlientPosiadaNumerKonta | async) === false">
        <div class="bank-account-inner centered-input-wrapper">
          <input
            [formControl]="numerKontaWprowadzony"
            type="text"
            class="text input"
            placeholder="Wpisz numer konta do wypłaty odszkodowania"
            mask="AA 00 0000 0000 0000 0000 0000 0000"
            appIban
          />

          <div class="input-error-message">
            <span
              class="c-label__title text-danger"
              [style.visibility]="numerKontaWprowadzony.value && numerKontaWprowadzony.errors ? 'visible' : 'hidden'"
            >
              Niepoprawny numer konta
            </span>
          </div>

          <div
            *ngIf="pokazKomunikat"
            class="information-border info-message-wrapper"
            [ngClass]="numerKontaWprowadzony.value && numerKontaWprowadzony.errors ? 'mt-3' : 'mt-2'"
          >
            <i class="c-icon u-icon--small u-margin-horizontal-small c-icon--9_31"></i>
            <span class="text info-text info-header">
              Dane zostały skopiowane, proszę sprawdzić ich poprawność.
            </span>
          </div>
        </div>
      </div>

      <div class="information-border mt-4 d-flex align-items-start">
        <i class="c-icon u-icon--small u-margin-horizontal-small c-icon--9_31"></i>
        <div>
          <p class="text info-text info-header">Odszkodowanie otrzymasz, jeśli:</p>
          <ul class="o-list-bare o-list-bare--dotted">
            <li class="o-list-bare__item text info-text">zaakceptujesz naszą propozycję,</li>
            <li class="o-list-bare__item text info-text">dokumentacja, którą nam dostarczysz, potwierdzi informacje ze zgłoszenia,</li>
            <li class="o-list-bare__item text info-text">przyjmiemy odpowiedzialność za to zdarzenie.</li>
          </ul>
        </div>
      </div>

      <div *ngIf="typUszkodzeniaMeble() || typUszkodzeniaSprzetAgdRtv()" class="mt-4">
        <span class="text item-type">{{ naglowekUszkodzenieMebliSprzetuAgdRtv() }}</span>
        <div class="mt-2">
          <span class="text content">
            Zgłoś osobno roszczenie dotyczące {{ komunikatUszkodzenieMebliSprzetuAgdRtv() }}.
            Możesz je utworzyć od razu po zakończeniu tego zgłoszenia.
          </span>
        </div>
      </div>

      <app-button-navigation
        [previousLabel]="'ODRZUĆ'"
        (previousClick)="odrzuc()"
        [nextEnabled]="numerKontaWprowadzony.errors === null"
        [nextLabel]="'ZAAKCEPTUJ'"
        (nextClick)="zaakceptuj()"
      ></app-button-navigation>

      <div class="mt-2 content-mobile">
        <span class="text content">
          Jeśli odrzucisz naszą propozycję, w ciągu kilku dni skontaktujemy się z&nbsp;Tobą i&nbsp;ustalimy dalsze kroki.
        </span>
      </div>

    </div>
  </div>
</div>
